export default __webpack_public_path__ + "static/media/5.b4f0b62f.webp";